module.exports = __webpack_public_path__ + "static/media/infoEmptyList.4959c6cf.svg";